import { render, staticRenderFns } from "./PurchaseOrderExternalItem.vue?vue&type=template&id=96a4a5c6&"
import script from "./PurchaseOrderExternalItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderExternalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports